import { DOCUMENT } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { environment } from '@environments/environment';
import { SiteLayoutComponent } from '@layout/site-layout/site-layout.component';
import { BraintreeService } from '@services/external-payments/braintree.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [SiteLayoutComponent, RouterOutlet],
})
export class AppComponent implements OnInit {
  private braintreeService = inject(BraintreeService);
  private titleService = inject(Title);
  private document = inject<Document>(DOCUMENT);
  private meta = inject(Meta);

  public ngOnInit(): void {
    this.setThemeColor();
    this.setSiteFavicon();
    this.titleService.setTitle(environment.titles.order);
    this.braintreeService.initializeDeviceData();
  }

  /**
   * Sets the theme color meta tag.
   */
  private setThemeColor(): void {
    this.meta.updateTag({ name: 'theme-color', content: environment.styles.metaThemeColor });
  }

  /**
   * Set site favicon dynamically for HealthLabs, STDCheck, TreatMyUTI.com, Starfish, Stallion, TestosteroneHQ.
   */
  private setSiteFavicon(): void {
    this.document.getElementById('appFavicon').setAttribute('href', `assets/img/${environment.faviconFile}`);
  }
}
